import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";
import { ApolloProvider } from "@apollo/client/react";
import { client } from "./apollo";

import { IS_LOCAL } from "./server-select";

// Mantine v8 CSS imports (required)
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/code-highlight/styles.css";
import "@mantine/tiptap/styles.css";
import "mantine-datatable/styles.layer.css";

// Import gaming animation system
import "./features/console/styles/animations.css";
import "./features/console/styles/bracket.css";

Sentry.init({
  dsn: "https://08900a48197f4bd1ad3b50b823ed3267@o99030.ingest.sentry.io/4504865976680448",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enabled: !IS_LOCAL,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
);
